module.exports = __webpack_public_path__ + "img/footer-icono-direccion.68eeb7cf.svg";